module.exports = __webpack_public_path__ + "static/media/cloudThree.1e370045.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Kiosk/CommitView/Intro/cloudThree.svg
// module id = 906
// module chunks = 0